import type { IGeoblockErrorScreenProps } from './GeoblockErrorScreen'

import { styled } from '@linaria/react'
import { Wrapper } from 'blocks/TextBlock'
import { MEDIA } from 'vars/index'

export const GeoblockErrorScreenStyled = styled.div<
  Omit<IGeoblockErrorScreenProps, 'children'>
>`
  width: calc(100vw - 32px);
  height: ${({ height }) => height ?? 'auto'};
  display: flex;
  flex-direction: ${({ direction }) => direction ?? 'initial'};
  align-items: flex-start;
  justify-content: center;
  padding: 0;

  ${MEDIA.MIN_600} {
    > ${Wrapper} {
      width: 400px;
    }
  }

  ${MEDIA.MIN_1640} {
    width: ${({ width }) => width ?? 'auto'};
    align-items: ${({ alignItems }) => alignItems ?? 'initial'};
    justify-content: ${({ justifyContent }) => justifyContent ?? 'initial'};
    padding: ${({ padding }) =>
      padding && padding.length > 0
        ? padding.map((item) => `var(${item})`)?.join(' ')
        : 0};

    > ${Wrapper} {
      width: 560px;
    }
  }
`
